import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useSkipTraceCurrentStep = () => {
  const { currentStep } = useSnapshot(skipTracingStore);

  return currentStep;
};
